import React from "react";
import { AnalyticsData } from "../../../Types/Dashboard";
import { FaTrophy, FaUserGraduate } from "react-icons/fa";

interface TopPerformersProps {
  analytics: AnalyticsData;
  loading?: boolean;
}

export default function TopPerformers({
  analytics,
  loading,
}: TopPerformersProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {[...Array(2)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-lg shadow p-6 animate-pulse"
          >
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div className="space-y-3">
              {[...Array(5)].map((_, j) => (
                <div key={j} className="h-12 bg-gray-200 rounded"></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      {/* Top Tutors */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <FaTrophy className="text-yellow-500" />
          Top Tuteurs
        </h3>
        <div className="space-y-3">
          {!analytics.top_tutors || analytics.top_tutors.length === 0 ? (
            <p className="text-gray-500 text-sm">Aucun tuteur</p>
          ) : (
            analytics.top_tutors.map((tutor, index) => (
              <div
                key={tutor.tutor_id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600 font-bold">
                    {index + 1}
                  </div>
                  <div>
                    <p className="font-medium text-sm">{tutor.tutor_name}</p>
                    <p className="text-xs text-gray-500">
                      {tutor.bookings_count} session{tutor.bookings_count > 1 ? "s" : ""}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Top Students */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <FaUserGraduate className="text-blue-500" />
          Top Étudiants
        </h3>
        <div className="space-y-3">
          {!analytics.top_students || analytics.top_students.length === 0 ? (
            <p className="text-gray-500 text-sm">Aucun étudiant</p>
          ) : (
            analytics.top_students.map((student, index) => (
              <div
                key={student.student_id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                    {index + 1}
                  </div>
                  <div>
                    <p className="font-medium text-sm">{student.student_name}</p>
                    <p className="text-xs text-gray-500">
                      {student.bookings_count} session{student.bookings_count > 1 ? "s" : ""}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
